import { Controller } from "stimulus"

// Menu deroulant Bulma (.dropdown) pilote au clic : ouverture, fermeture
// au clic exterieur et a Escape, aria-expanded synchronise.
export default class extends Controller {
  static targets = ["trigger"]

  connect() {
    this.onDocumentClick = this.onDocumentClick.bind(this)
    this.onDocumentKeydown = this.onDocumentKeydown.bind(this)
    document.addEventListener("click", this.onDocumentClick)
    document.addEventListener("keydown", this.onDocumentKeydown)
  }

  disconnect() {
    document.removeEventListener("click", this.onDocumentClick)
    document.removeEventListener("keydown", this.onDocumentKeydown)
  }

  toggle(event) {
    event.preventDefault()
    this.setOpen(!this.isOpen())
  }

  close() {
    this.setOpen(false)
  }

  isOpen() {
    return this.element.classList.contains("is-active")
  }

  setOpen(open) {
    this.element.classList.toggle("is-active", open)
    if (this.hasTriggerTarget) {
      this.triggerTarget.setAttribute("aria-expanded", open ? "true" : "false")
    }
  }

  onDocumentClick(event) {
    if (this.isOpen() && !this.element.contains(event.target)) this.close()
  }

  onDocumentKeydown(event) {
    if (event.key === "Escape" && this.isOpen()) {
      this.close()
      if (this.hasTriggerTarget) this.triggerTarget.focus()
    }
  }
}
